(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-announcement-bar-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var autoplay = root.hasAttribute('data-auto-play');
      var cycleSpeed = parseInt(root.getAttribute('data-cycle-speed'), 10) || 5;
      var items = Array.from(root.querySelectorAll('.zlf-ab-01__item'));
      if (items.length < 2) return;

      var hasPendingTransition = false;
      var interval = null;

      function selectedIndex() {
        return items.findIndex(function (item) { return !item.hasAttribute('hidden'); });
      }

      function deselect(item, animate) {
        return new Promise(function (resolve) {
          item.animate(
            { transform: ['translateY(0)', 'translateY(-8px)'], opacity: [1, 0] },
            { duration: animate ? 150 : 0, easing: 'ease-in-out' }
          ).onfinish = function () {
            item.setAttribute('hidden', '');
            resolve();
          };
        });
      }

      function select(item, animate) {
        return new Promise(function (resolve) {
          item.removeAttribute('hidden');
          item.animate(
            { transform: ['translateY(8px)', 'translateY(0)'], opacity: [0, 1] },
            { duration: animate ? 150 : 0, easing: 'ease-in-out' }
          ).onfinish = resolve;
        });
      }

      function go(index, animate) {
        if (animate === undefined) animate = true;
        var current = selectedIndex();
        if (current === index || hasPendingTransition) return;
        if (autoplay) pausePlayer();
        hasPendingTransition = true;
        deselect(items[current], animate).then(function () {
          return select(items[index], animate);
        }).then(function () {
          hasPendingTransition = false;
          if (autoplay) startPlayer();
        });
      }

      function prev() {
        go((selectedIndex() - 1 + items.length) % items.length);
      }

      function next() {
        go((selectedIndex() + 1) % items.length);
      }

      function startPlayer() {
        pausePlayer();
        interval = setInterval(next, cycleSpeed * 1000);
      }

      function pausePlayer() {
        if (interval) { clearInterval(interval); interval = null; }
      }

      var prevBtn = root.querySelector('[data-action="prev"]');
      var nextBtn = root.querySelector('[data-action="next"]');
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      if (window.ResizeObserver) {
        new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === root) {
              var height = entry.borderBoxSize
                ? (entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize)
                : entry.target.clientHeight;
              document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
            }
          });
        }).observe(root);
      }

      if (Shopify.designMode) {
        root.addEventListener('shopify:block:select', function (e) {
          var idx = items.indexOf(e.target);
          if (idx !== -1) go(idx, false);
        });
      }

      if (autoplay) startPlayer();
    }

    var boot = function () { document.querySelectorAll('[data-announcement]').forEach(init); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-announcement]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-before-after-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(container) {
      if (container.hasAttribute('data-ba-inited')) return;
      container.setAttribute('data-ba-inited', '1');

      var handle = container.querySelector('.zlf-before-after-01__handle');
      var beforeLayer = container.querySelector('.zlf-before-after-01__layer--before');
      if (!handle || !beforeLayer) return;

      var hasReveal = container.hasAttribute('data-reveal');
      var initial = parseFloat(container.getAttribute('data-initial')) || 50;
      var dragging = false;

      function setPosition(pct) {
        pct = Math.max(0, Math.min(100, pct));
        container.style.setProperty('--zlf-ba-position', pct + '%');
        handle.style.left = pct + '%';
        beforeLayer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }

      function getPct(clientX) {
        var rect = container.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });

      container.addEventListener('pointerdown', function (e) {
        if (e.target === handle || handle.contains(e.target)) return;
        dragging = true;
        setPosition(getPct(e.clientX));
      });

      document.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        setPosition(getPct(e.clientX));
      });

      document.addEventListener('pointerup', function () {
        dragging = false;
      });

      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
          e.preventDefault();
          setPosition(current - step);
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
          e.preventDefault();
          setPosition(current + step);
        }
      });

      if (hasReveal && !designMode && !prefersReduced && typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            entry.target.classList.add('is-visible');
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
        observer.observe(container);
      } else {
        container.classList.add('is-visible');
      }
    }

    function boot() {
      document.querySelectorAll('[data-zlf-ba]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-zlf-ba]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-collection-list-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      /* ---------- Carousel scroll ---------- */
      var scroller = section.querySelector('.zlf-cl-01__scroller');
      if (scroller) {
        var prevBtn = section.querySelector('.zlf-cl-01__arrow--prev');
        var nextBtn = section.querySelector('.zlf-cl-01__arrow--next');
        var items = scroller.querySelectorAll('.zlf-cl-01__item');

        if (prevBtn && nextBtn && items.length) {
          prevBtn.addEventListener('click', function () {
            scroller.scrollBy({ left: -items[0].clientWidth, behavior: 'smooth' });
          });
          nextBtn.addEventListener('click', function () {
            scroller.scrollBy({ left: items[0].clientWidth, behavior: 'smooth' });
          });
        }
      }

      /* ---------- Reveal-on-scroll ---------- */
      var revealGrid = section.querySelector('[data-zlf-cl-01-reveal]');
      if (!revealGrid) return;

      var revealItems = revealGrid.querySelectorAll('.zlf-cl-01__item');
      if (!revealItems.length) return;

      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || typeof IntersectionObserver === 'undefined') {
        for (var i = 0; i < revealItems.length; i++) {
          revealItems[i].classList.add('is-in');
        }
        return;
      }

      var staggerDelay = 150;
      var isCarousel = revealGrid.classList.contains('zlf-cl-01__grid--carousel');

      if (isCarousel) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              for (var k = 0; k < revealItems.length; k++) {
                (function (idx) {
                  setTimeout(function () {
                    revealItems[idx].classList.add('is-in');
                  }, idx * staggerDelay);
                })(k);
              }
              cio.disconnect();
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
        cio.observe(section);
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var el = entry.target;
              var idx = parseInt(el.getAttribute('data-zlf-reveal-idx'), 10) || 0;
              setTimeout(function () {
                el.classList.add('is-in');
              }, idx * staggerDelay);
              io.unobserve(el);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

        for (var j = 0; j < revealItems.length; j++) {
          revealItems[j].setAttribute('data-zlf-reveal-idx', j);
          io.observe(revealItems[j]);
        }
      }
    }

    document.querySelectorAll('.zlf-cl-01-section').forEach(initSection);

    document.addEventListener('shopify:section:load', function (evt) {
      var section = evt.target.querySelector('.zlf-cl-01-section');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-countdown-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.zlf-countdown-01[data-zlf-countdown]');
    if (!roots.length) return;

    roots.forEach(root => {
      const targetRaw = root.getAttribute('data-target');
      if (!targetRaw) return;

      const target = Date.parse(targetRaw);
      if (isNaN(target)) return;

      const hideOnComplete = root.getAttribute('data-hide-on-complete') === 'true';
      const dEl = root.querySelector('[data-zlf-cd-days]');
      const hEl = root.querySelector('[data-zlf-cd-hours]');
      const mEl = root.querySelector('[data-zlf-cd-minutes]');
      const sEl = root.querySelector('[data-zlf-cd-seconds]');

      const pad = n => String(Math.max(0, n)).padStart(2, '0');

      function tick() {
        const diff = target - Date.now();
        if (diff <= 0) {
          if (dEl) dEl.textContent = '00';
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          if (hideOnComplete) {
            root.classList.add('is-hidden');
          } else {
            root.classList.add('is-complete');
          }
          clearInterval(timer);
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }

      tick();
      const timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-faq-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.zlf-faq-01[data-single-open="true"]').forEach(function (root) {
      var items = root.querySelectorAll('details.zlf-faq-01__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-faq-02"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.zlf-faq-02[data-zlf-faq-02]');
    if (!roots.length) return;

    roots.forEach(root => {
      // Smooth-scroll anchor links for sidebar nav
      const navLinks = root.querySelectorAll('[data-zlf-faq-02-nav-link]');
      navLinks.forEach(link => {
        link.addEventListener('click', e => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;
          const target = document.getElementById(href.slice(1));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', href);
        });
      });

      // Toggle open/close with WAAPI animation (matches legacy CollapsibleContent)
      const dur = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500;
      const ease = 'cubic-bezier(0.75, 0, 0.175, 1)';

      function toggle(item, open) {
        const btn = item.querySelector('.zlf-faq-02__question');
        const answer = item.querySelector('.zlf-faq-02__answer');
        if (!answer) return;

        if (open) {
          item.classList.add('is-open');
          if (btn) btn.setAttribute('aria-expanded', 'true');
          answer.style.overflow = 'hidden';
          answer.animate(
            { height: ['0px', answer.scrollHeight + 'px'], visibility: ['hidden', 'visible'] },
            { duration: dur, easing: ease }
          ).onfinish = () => { answer.style.overflow = ''; };
        } else {
          const h = answer.offsetHeight;
          answer.style.overflow = 'hidden';
          answer.animate(
            { height: [h + 'px', '0px'], visibility: ['visible', 'hidden'] },
            { duration: dur, easing: ease }
          ).onfinish = () => {
            item.classList.remove('is-open');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            answer.style.overflow = '';
          };
        }
      }

      root.querySelectorAll('.zlf-faq-02__item').forEach(item => {
        const btn = item.querySelector('.zlf-faq-02__question');
        if (!btn) return;
        btn.addEventListener('click', () => {
          toggle(item, !item.classList.contains('is-open'));
        });
      });

      // Shopify editor: auto-open on block select
      if (window.Shopify && window.Shopify.designMode) {
        root.addEventListener('shopify:block:select', e => {
          const item = e.target.closest('.zlf-faq-02__item');
          if (item && !item.classList.contains('is-open')) toggle(item, true);
        });
        root.addEventListener('shopify:block:deselect', e => {
          const item = e.target.closest('.zlf-faq-02__item');
          if (item && item.classList.contains('is-open')) toggle(item, false);
        });
      }

      // Scroll-spy: highlight nav-link for visible category
      if (!navLinks.length || typeof IntersectionObserver === 'undefined') return;
      const categories = root.querySelectorAll('.zlf-faq-02__category');
      if (!categories.length) return;
      const linkById = new Map();
      navLinks.forEach(l => {
        const href = l.getAttribute('href');
        if (href && href.startsWith('#')) linkById.set(href.slice(1), l);
      });
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            navLinks.forEach(l => l.classList.remove('is-current'));
            const link = linkById.get(entry.target.id);
            if (link) link.classList.add('is-current');
          }
        });
      }, { rootMargin: '-80px 0px -60% 0px', threshold: 0 });
      categories.forEach(c => io.observe(c));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-gallery-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const list = root.querySelector('[data-gallery-list]');
      const progress = root.querySelector('[data-gallery-progress]');
      const prevBtn = root.querySelector('[data-dir="prev"]');
      const nextBtn = root.querySelector('[data-dir="next"]');
      if (!list) return;

      const items = Array.from(list.querySelectorAll('[data-gallery-item]'));
      const count = items.length;
      if (count < 2) return;

      // Default progress = one item width
      const updateProgress = () => {
        if (!progress) return;
        const max = list.scrollWidth - list.clientWidth;
        if (max <= 0) {
          progress.style.width = '100%';
          return;
        }
        const ratio = list.scrollLeft / max;
        // Bar width = one-item share + scroll progress across remaining
        const base = 100 / count;
        const width = base + (100 - base) * ratio;
        progress.style.width = width + '%';
      };

      const updateArrows = () => {
        if (!prevBtn || !nextBtn) return;
        const max = list.scrollWidth - list.clientWidth;
        prevBtn.toggleAttribute('disabled', list.scrollLeft <= 2);
        nextBtn.toggleAttribute('disabled', list.scrollLeft >= max - 2);
      };

      const scrollByItem = (dir) => {
        const rect = list.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        let targetIndex = 0;
        if (dir === 'next') {
          targetIndex = items.findIndex((el) => el.getBoundingClientRect().left > center);
          if (targetIndex < 0) targetIndex = count - 1;
        } else {
          const reversed = items.slice().reverse();
          const r = reversed.findIndex((el) => el.getBoundingClientRect().right < center);
          targetIndex = r < 0 ? 0 : count - 1 - r;
        }
        const target = items[targetIndex];
        const targetRect = target.getBoundingClientRect();
        list.scrollBy({
          left: targetRect.left - rect.left - (rect.width - targetRect.width) / 2,
          behavior: 'smooth',
        });
      };

      list.addEventListener('scroll', () => {
        updateProgress();
        updateArrows();
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByItem('prev'));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByItem('next'));

      // Initial
      updateProgress();
      updateArrows();
    }

    const boot = () => document.querySelectorAll('.zlf-gallery-01').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.zlf-gallery-01').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-gallery-carousel-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(stage) {
      const track = stage.querySelector('[data-track]');
      const dots = Array.from(stage.querySelectorAll('.zlf-gallery-carousel-01__dot'));
      const slides = Array.from(track ? track.children : []);
      if (!track || slides.length < 2) return;

      let currentIndex = 0;
      const setActive = (i) => {
        if (i === currentIndex) return;
        currentIndex = i;
        dots.forEach((d, idx) => {
          const active = idx === i;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      // IntersectionObserver on slides → sync dot
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && e.intersectionRatio > 0.5) {
              const idx = slides.indexOf(e.target);
              if (idx >= 0) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.5, 0.9] });
        slides.forEach((s) => io.observe(s));
      }

      // Dot click → scroll target into view
      dots.forEach((d) => {
        d.addEventListener('click', () => {
          const idx = parseInt(d.getAttribute('data-index'), 10) || 0;
          const target = slides[idx];
          if (!target) return;
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    const boot = () => document.querySelectorAll('[data-carousel].zlf-gallery-carousel-01__stage').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-carousel].zlf-gallery-carousel-01__stage').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-image-with-text-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.zlf-iwt-01[data-zlf-iwt-01]');
    if (!roots.length) return;

    roots.forEach(root => {
      const medias = root.querySelectorAll('[data-zlf-iwt-01-media]');
      const tabs = root.querySelectorAll('[data-zlf-iwt-01-tab]');
      const panels = root.querySelectorAll('[data-zlf-iwt-01-panel]');
      const cycleRaw = root.getAttribute('data-cycle-speed');
      const cycle = parseInt(cycleRaw, 10);

      function activate(idx) {
        if (!panels.length) return;
        const n = panels.length;
        idx = ((idx % n) + n) % n;
        medias.forEach((el, i) => {
          el.classList.toggle('is-current', i === idx);
          if (i === idx) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
        tabs.forEach((el, i) => {
          el.classList.toggle('is-current', i === idx);
          el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        panels.forEach((el, i) => {
          el.classList.toggle('is-current', i === idx);
          if (i === idx) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
      }

      tabs.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.getAttribute('data-zlf-iwt-01-tab'), 10);
          if (!isNaN(idx)) activate(idx);
          stopCycle();
        });
      });

      // Auto-cycle
      let timer = null;
      function stopCycle() { if (timer) { clearInterval(timer); timer = null; } }
      function startCycle() {
        if (panels.length <= 1 || isNaN(cycle) || cycle < 2) return;
        timer = setInterval(() => {
          const currentTab = root.querySelector('[data-zlf-iwt-01-tab].is-current');
          const idx = currentTab ? parseInt(currentTab.getAttribute('data-zlf-iwt-01-tab'), 10) : 0;
          activate(idx + 1);
        }, cycle * 1000);
      }
      startCycle();

      // Reveal-on-scroll
      if (root.classList.contains('zlf-iwt-01--reveal')) {
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduce && typeof IntersectionObserver !== 'undefined') {
          root.classList.add('zlf-iwt-01--js');
          const io = new IntersectionObserver(entries => {
            entries.forEach(e => {
              if (e.isIntersecting) {
                root.classList.add('is-in');
                io.unobserve(root);
              }
            });
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
          io.observe(root);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-image-with-text-overlay-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.zlf-iwto-01[data-zlf-iwto-01]');
    if (!roots.length) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') return;
    roots.forEach(root => {
      if (!root.classList.contains('zlf-iwto-01--reveal')) return;
      root.classList.add('zlf-iwto-01--js');
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-media-grid-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      section.classList.add('zlf-media-grid-01-section--js');
      if (!section.classList.contains('zlf-media-grid-01-section--reveal')) return;
      if (!('IntersectionObserver' in window)) {
        section.classList.add('zlf-media-grid-01-section--in');
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            section.classList.add('zlf-media-grid-01-section--in');
            io.unobserve(section);
          }
        });
      }, { threshold: 0.05 });
      io.observe(section);
    }
    const boot = () => document.querySelectorAll('.zlf-media-grid-01-section').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.zlf-media-grid-01-section').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-milestone-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMilestone(root) {
      var items = Array.from(root.querySelectorAll('.zlf-ms-01__item'));
      if (!items.length) return;

      var hasReveal = root.hasAttribute('data-reveal');
      if (!hasReveal) return;

      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (typeof IntersectionObserver === 'undefined' || prefersReduced) {
        items.forEach(function (item) { item.style.opacity = '1'; });
        return;
      }

      var threshold = root.clientHeight > 0 ? Math.min(50 / root.clientHeight, 1) : 0;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            var isMobile = window.innerWidth < 1000;

            items.forEach(function (item, index) {
              var delay = 200 * index - Math.min(3 * index * index, 100 * index);
              item.animate(
                {
                  opacity: [0, 1],
                  transform: ['translateY(' + (isMobile ? 35 : 60) + 'px)', 'translateY(0)']
                },
                {
                  duration: 600,
                  delay: Math.max(0, delay),
                  easing: 'ease',
                  fill: 'forwards'
                }
              );
            });
          }
        });
      }, { threshold: threshold });

      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-zlf-milestone]').forEach(initMilestone);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-zlf-milestone]').forEach(initMilestone);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-newsletter-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.zlf-newsletter-01[data-zlf-reveal="true"]');
    if (!sections.length) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') {
      // No animation path — leave content fully visible.
      return;
    }
    sections.forEach(s => s.classList.add('zlf-newsletter-01--js'));
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    sections.forEach(s => s.querySelectorAll('[data-zlf-reveal-item]').forEach(i => io.observe(i)));

    // Loader button
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    document.querySelectorAll('.zlf-newsletter-01__button').forEach(btn => {
      btn.addEventListener('click', e => {
        const form = btn.closest('form');
        if (!form || !form.checkValidity()) return;
        if (btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }

        const txt = btn.querySelector('.zlf-newsletter-01__btn-text');
        const ldr = btn.querySelector('.zlf-newsletter-01__btn-loader');
        if (!txt || !ldr) return;

        btn.setAttribute('aria-busy', 'true');
        txt.animate(
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] },
          { duration: 75, easing: 'ease', fill: 'forwards' }
        );
        ldr.hidden = false;
        ldr.animate(
          { opacity: [0, 1], transform: ['translate(-50%, 0%)', 'translate(-50%, -50%)'] },
          { duration: 75, delay: 75, easing: 'ease', fill: 'forwards' }
        );

        if (isSafari) {
          e.preventDefault();
          setTimeout(() => form.submit(), 250);
        }
      });

      window.addEventListener('pagehide', () => {
        if (btn.getAttribute('aria-busy') !== 'true') return;
        btn.removeAttribute('aria-busy');
        const txt = btn.querySelector('.zlf-newsletter-01__btn-text');
        const ldr = btn.querySelector('.zlf-newsletter-01__btn-loader');
        if (!txt || !ldr) return;
        ldr.animate(
          { opacity: [1, 0], transform: ['translate(-50%, -50%)', 'translate(-50%, -100%)'] },
          { duration: 75, delay: 100, easing: 'ease', fill: 'forwards' }
        ).onfinish = () => { ldr.hidden = true; };
        txt.animate(
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 75, delay: 175, easing: 'ease', fill: 'forwards' }
        );
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-newsletter-popup-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var sectionId = root.getAttribute('data-section-id');
      var delayMs = (parseFloat(root.getAttribute('data-delay')) || 3) * 1000;
      var remember = root.getAttribute('data-remember') === 'true';
      var key = 'zlf-np-01-seen-' + sectionId;

      if (remember) {
        try {
          if (localStorage.getItem(key) === '1') return;
        } catch (e) {}
      }

      function open() {
        root.hidden = false;
        root.removeAttribute('hidden');
        root.setAttribute('aria-hidden', 'false');
        /* visibility transition needs a frame */
        requestAnimationFrame(function() {
          root.classList.add('is-open');
        });
      }
      function close() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        setTimeout(function() { root.hidden = true; }, 700);
        if (remember) {
          try { localStorage.setItem(key, '1'); } catch (e) {}
        }
      }

      /* floating label: mark filled */
      root.querySelectorAll('.zlf-np-01__input').forEach(function(inp) {
        function check() {
          inp.classList.toggle('is-filled', inp.value.length > 0);
        }
        inp.addEventListener('input', check);
        inp.addEventListener('change', check);
        check();
      });

      /* loader button: text slides out, spinner slides in (matches legacy loader-button) */
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      root.querySelectorAll('.zlf-np-01__submit').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          var form = btn.closest('form');
          if (!form || !form.checkValidity()) return;
          if (btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }

          var txt = btn.querySelector('.zlf-np-01__btn-text');
          var ldr = btn.querySelector('.zlf-np-01__btn-loader');
          if (!txt || !ldr) return;

          btn.setAttribute('aria-busy', 'true');
          txt.animate(
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] },
            { duration: 75, easing: 'ease', fill: 'forwards' }
          );
          ldr.hidden = false;
          ldr.animate(
            { opacity: [0, 1], transform: ['translate(-50%, 0%)', 'translate(-50%, -50%)'] },
            { duration: 75, delay: 75, easing: 'ease', fill: 'forwards' }
          );

          if (isSafari) {
            e.preventDefault();
            setTimeout(function() { form.submit(); }, 250);
          }
        });

        window.addEventListener('pagehide', function() {
          if (btn.getAttribute('aria-busy') !== 'true') return;
          btn.removeAttribute('aria-busy');
          var txt = btn.querySelector('.zlf-np-01__btn-text');
          var ldr = btn.querySelector('.zlf-np-01__btn-loader');
          if (!txt || !ldr) return;
          ldr.animate(
            { opacity: [1, 0], transform: ['translate(-50%, -50%)', 'translate(-50%, -100%)'] },
            { duration: 75, delay: 100, easing: 'ease', fill: 'forwards' }
          ).onfinish = function() { ldr.hidden = true; };
          txt.animate(
            { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
            { duration: 75, delay: 175, easing: 'ease', fill: 'forwards' }
          );
        });
      });

      if (root.querySelector('.zlf-np-01__banner--success')) {
        open();
      } else {
        setTimeout(open, delayMs);
      }

      root.querySelectorAll('[data-close]').forEach(function(el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });
    }

    function boot() {
      document.querySelectorAll('[data-newsletter-popup]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('[data-newsletter-popup]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-photo-feed-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.zlf-photo-feed-01[data-zlf-photo-feed-01]');
    if (!roots.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') return;
    roots.forEach(function (root) {
      if (!root.classList.contains('zlf-photo-feed-01--reveal')) return;
      root.classList.add('zlf-photo-feed-01--js');
      var items = root.querySelectorAll('[data-zlf-reveal-item]');

      /* [legacy delay formula: 100 * index - Math.min(3 * index * index, 100 * index)] */
      items.forEach(function (el, i) {
        var delay = reduce ? 0 : 100 * i - Math.min(3 * i * i, 100 * i);
        el.style.setProperty('--zlf-pf-delay', Math.max(0, delay) + 'ms');
      });

      /* [legacy: observe section root, wait for images, then reveal all at once] */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            io.disconnect();
            /* Wait for all images inside the section to load */
            var images = Array.from(root.querySelectorAll('.zlf-photo-feed-01__image'));
            var promises = images.map(function (img) {
              if (img.tagName === 'IMG' && !img.complete) {
                return new Promise(function (resolve) {
                  img.addEventListener('load', resolve, { once: true });
                  img.addEventListener('error', resolve, { once: true });
                });
              }
              return Promise.resolve();
            });
            Promise.all(promises).then(function () {
              items.forEach(function (el) {
                el.classList.add('is-in');
              });
            });
          }
        });
      }, { rootMargin: '30px 0px', threshold: 0 });
      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-privacy-banner-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const sectionId = root.getAttribute('data-section-id');
      const key = 'zlf-pb-01-dismissed-' + sectionId;

      try {
        if (localStorage.getItem(key) === '1') return;
      } catch (e) { /* storage disabled */ }

      root.hidden = false;
      requestAnimationFrame(() => {
        root.classList.add('is-visible');
      });

      const accept = root.querySelector('[data-accept]');
      if (accept) {
        accept.addEventListener('click', () => {
          root.classList.remove('is-visible');
          setTimeout(() => { root.hidden = true; }, 260);
          try { localStorage.setItem(key, '1'); } catch (e) {}
        });
      }
    }

    const boot = () => document.querySelectorAll('[data-privacy-banner]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-privacy-banner]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-slideshow-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(container) {
      container.classList.add('zlf-slideshow-01--js');
      const isFade = container.closest('.zlf-slideshow-01-section--t-fade');
      const track = container.querySelector('[data-track]');
      const dots = Array.from(container.querySelectorAll('.zlf-slideshow-01__dot'));
      const slides = Array.from(track ? track.children : []);
      if (!track || slides.length < 1) return;

      const autoplay = container.getAttribute('data-autoplay') === 'true';
      const cycle = (parseInt(container.getAttribute('data-cycle'), 10) || 5) * 1000;
      let currentIndex = 0;
      let autoTimer = null;
      let paused = false;

      const setActive = (i) => {
        currentIndex = i;
        dots.forEach((d, idx) => {
          const active = idx === i;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
        if (autoplay) resetProgress();
      };

      const resetProgress = () => {
        const active = dots[currentIndex];
        if (!active) return;
        const bar = active.querySelector('.zlf-slideshow-01__dot-progress');
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.setProperty('--zlf-ss-01-progress', '0%');
        bar.getBoundingClientRect();
        bar.style.transition = 'background ' + cycle + 'ms linear';
        bar.style.setProperty('--zlf-ss-01-progress', '100%');
        // fallback animation using JS since conic-gradient on CSS var can't animate
        animateRing(bar, cycle);
      };

      const animateRing = (bar, duration) => {
        if (bar._raf) cancelAnimationFrame(bar._raf);
        const start = performance.now();
        const step = (now) => {
          if (paused) { bar._pauseAt = now; return; }
          const progress = Math.min(100, ((now - start) / duration) * 100);
          bar.style.setProperty('--zlf-ss-01-progress', progress + '%');
          if (progress < 100) bar._raf = requestAnimationFrame(step);
        };
        bar._raf = requestAnimationFrame(step);
      };

      const goTo = (i) => {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        if (isFade) {
          setActive(i);
        } else {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          setActive(i);
        }
      };

      const advance = () => goTo(currentIndex + 1);

      const startAuto = () => {
        if (!autoplay || slides.length < 2) return;
        stopAuto();
        autoTimer = setInterval(advance, cycle);
        resetProgress();
      };
      const stopAuto = () => {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      };

      // Track scroll → sync active dot (non-fade mode)
      if (!isFade && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && e.intersectionRatio > 0.6) {
              const idx = slides.indexOf(e.target);
              if (idx >= 0 && idx !== currentIndex) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.6, 0.95] });
        slides.forEach((s) => io.observe(s));
      }

      dots.forEach((d) => {
        d.addEventListener('click', () => {
          const idx = parseInt(d.getAttribute('data-index'), 10) || 0;
          goTo(idx);
          stopAuto();
          if (autoplay) startAuto();
        });
      });

      // Pause on user interaction with track
      if (!isFade) {
        track.addEventListener('pointerdown', stopAuto, { passive: true });
        track.addEventListener('pointerup', () => autoplay && startAuto(), { passive: true });
      }

      setActive(0);
      startAuto();
    }

    const boot = () => document.querySelectorAll('[data-slideshow]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-slideshow]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-stats-counter-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateValue(el, target, decimals, duration) {
      var start = performance.now();
      function tick(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var value = target * easeOutCubic(progress);
        el.textContent = value.toFixed(decimals);
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function init(root) {
      if (root.hasAttribute('data-zlf-stats-inited')) return;
      root.setAttribute('data-zlf-stats-inited', '1');

      var duration = parseInt(root.getAttribute('data-duration'), 10) || 1600;
      var hasReveal = root.hasAttribute('data-reveal');
      var stats = root.querySelectorAll('[data-zlf-stat]');
      if (!stats.length) return;

      if (prefersReduced || typeof IntersectionObserver === 'undefined') {
        stats.forEach(function (stat) { stat.classList.add('is-visible'); });
        return;
      }

      if (designMode) {
        stats.forEach(function (stat) { stat.classList.add('is-visible'); });
        stats.forEach(function (stat, i) {
          var valueEl = stat.querySelector('[data-zlf-stat-value]');
          if (!valueEl) return;
          var target = parseFloat(stat.getAttribute('data-target')) || 0;
          var decimals = parseInt(stat.getAttribute('data-decimals'), 10) || 0;
          valueEl.textContent = '0';
          setTimeout(function () {
            animateValue(valueEl, target, decimals, duration);
          }, i * 120);
        });
        return;
      }

      stats.forEach(function (stat) {
        var valueEl = stat.querySelector('[data-zlf-stat-value]');
        if (valueEl) valueEl.textContent = '0';
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);

          stats.forEach(function (stat, i) {
            var valueEl = stat.querySelector('[data-zlf-stat-value]');
            if (!valueEl) return;
            var target = parseFloat(stat.getAttribute('data-target')) || 0;
            var decimals = parseInt(stat.getAttribute('data-decimals'), 10) || 0;
            var delay = i * 120;
            setTimeout(function () {
              if (hasReveal) stat.classList.add('is-visible');
              animateValue(valueEl, target, decimals, duration);
            }, delay);
          });
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' });

      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-zlf-stats]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-zlf-stats]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-stories-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      section.classList.add('zlf-stories-01-section--js');
      if (!section.classList.contains('zlf-stories-01-section--reveal')) return;
      if (!('IntersectionObserver' in window)) {
        section.classList.add('zlf-stories-01-section--in');
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            section.classList.add('zlf-stories-01-section--in');
            io.unobserve(section);
          }
        });
      }, { threshold: section.clientHeight > 0 ? Math.min(50 / section.clientHeight, 1) : 0 });
      io.observe(section);
    }
    const boot = () => document.querySelectorAll('.zlf-stories-01-section').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.zlf-stories-01-section').forEach(init);
    });
    document.addEventListener('shopify:block:select', (e) => {
      if (e.target.closest('.zlf-stories-01-section')) {
        e.target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: e.detail.load ? 'auto' : 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-tabs-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.getAttribute('data-zlf-tabs-inited')) return;
      root.setAttribute('data-zlf-tabs-inited', '1');

      var tablist = root.querySelector('[role="tablist"]');
      if (!tablist) return;
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function activate(tab) {
        tabs.forEach(function (t) {
          var selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        tab.focus();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab); });
      });

      tablist.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(document.activeElement);
        if (idx < 0) return;
        var next;
        if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next); }
      });
    }

    function boot() {
      document.querySelectorAll('[data-zlf-tabs]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-zlf-tabs]');
      if (el) { el.removeAttribute('data-zlf-tabs-inited'); init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-testimonials-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('.zlf-testimonials-01[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-text-with-icons-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.zlf-twi-01[data-zlf-twi-01]');
    if (!roots.length) return;
    roots.forEach(root => {
      const viewport = root.querySelector('[data-zlf-twi-01-viewport]');
      const dots = root.querySelectorAll('[data-zlf-twi-01-dot]');
      const slides = root.querySelectorAll('[data-zlf-twi-01-slide]');
      if (!viewport || !dots.length || !slides.length) return;

      dots.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.getAttribute('data-zlf-twi-01-dot'), 10);
          const target = slides[idx];
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      // Update active dot on scroll
      if (typeof IntersectionObserver === 'undefined') return;
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const idx = parseInt(entry.target.getAttribute('data-zlf-twi-01-slide'), 10);
          dots.forEach((d, i) => {
            const active = i === idx;
            d.classList.toggle('is-current', active);
            d.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      }, { root: viewport, threshold: 0.6 });
      slides.forEach(s => io.observe(s));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-video-bubble-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const sectionId = root.getAttribute('data-section-id');
      const onceKey = 'zlf-vb-01-seen-' + sectionId;
      const onlyOnce = root.getAttribute('data-only-once') === 'true';

      if (onlyOnce) {
        try {
          if (localStorage.getItem(onceKey) === '1') {
            root.style.display = 'none';
            return;
          }
        } catch (e) { /* storage disabled */ }
      }

      const bubble = root.querySelector('[data-bubble]');
      const closeBubble = root.querySelector('[data-bubble-close]');
      const openBtn = root.querySelector('[data-bubble-open]');
      const modal = root.querySelector('[data-modal]');
      const modalCloses = root.querySelectorAll('[data-modal-close]');
      const mainVideo = root.querySelector('[data-main-video]');
      const mainIframe = root.querySelector('[data-main-iframe]');

      var previewVideo = root.querySelector('.zlf-video-bubble-01__preview');
      if (previewVideo && previewVideo.paused) {
        previewVideo.play().catch(function() {});
      }

      if (closeBubble) {
        closeBubble.addEventListener('click', (e) => {
          e.stopPropagation();
          bubble.classList.add('is-hidden');
          if (onlyOnce) {
            try { localStorage.setItem(onceKey, '1'); } catch (e) {}
          }
          setTimeout(() => { bubble.style.display = 'none'; }, 320);
        });
      }

      if (openBtn && modal) {
        openBtn.addEventListener('click', () => {
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          if (mainVideo && mainVideo.play && !mainVideo.hasAttribute('autoplay')) {
            mainVideo.play().catch(() => {});
          }
          if (mainIframe) {
            const src = mainIframe.getAttribute('data-src');
            if (src && !mainIframe.getAttribute('src')) {
              mainIframe.setAttribute('src', src);
            }
          }
          document.body.style.overflow = 'hidden';
        });
      }

      const closeModal = () => {
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        if (mainVideo && mainVideo.pause) mainVideo.pause();
        if (mainIframe) mainIframe.setAttribute('src', '');
        document.body.style.overflow = '';
      };

      modalCloses.forEach((el) => el.addEventListener('click', closeModal));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
    }

    const boot = () => document.querySelectorAll('[data-video-bubble]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-video-bubble]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-video-carousel-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-track]');
      var cards = Array.from(root.querySelectorAll('[data-card]'));
      var prevBtn = root.querySelector('[data-dir="prev"]');
      var nextBtn = root.querySelector('[data-dir="next"]');
      var modal = root.querySelector('[data-modal]');
      var modalMedia = root.querySelector('[data-modal-media]');
      var modalCloses = root.querySelectorAll('[data-modal-close]');

      /* --- Stagger entrance animation (legacy IntersectionObserver + translateY) --- */
      if (cards.length > 0) {
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        cards.forEach(function (card) { card.style.opacity = '0'; });

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            cards.forEach(function (card, index) {
              var yShift = prefersReducedMotion ? 0 : (window.innerWidth < 1000 ? 35 : 60);
              var delay = prefersReducedMotion ? 0 : (100 * index - Math.min(3 * index * index, 100 * index));
              card.animate(
                [
                  { opacity: 0, transform: 'translateY(' + yShift + 'px)' },
                  { opacity: 1, transform: 'translateY(0)' }
                ],
                { duration: 600, delay: Math.max(0, delay), easing: 'ease', fill: 'forwards' }
              );
            });
          });
        }, { threshold: 0 });
        observer.observe(root);
      }

      /* --- Arrow scroll (legacy scrolls by clientWidth + columnGap) --- */
      var scrollByPage = function (dir) {
        if (!track) return;
        var gap = parseInt(getComputedStyle(track).columnGap) || 24;
        var amount = track.clientWidth + gap;
        track.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
      };

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage('prev'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage('next'); });

      var updateArrows = function () {
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.toggleAttribute('disabled', track.scrollLeft <= 0);
        if (nextBtn) nextBtn.toggleAttribute('disabled', track.scrollLeft >= max - 2);
      };
      if (track) {
        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      }

      /* --- Modal open --- */
      var openModal = function (card) {
        if (!modal || !modalMedia) return;
        var type = card.getAttribute('data-main-type');
        var src = card.getAttribute('data-main-src');
        modalMedia.innerHTML = '';
        if (type === 'file') {
          var videoTemplate = card.querySelector('video');
          var video = document.createElement('video');
          video.setAttribute('controls', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('playsinline', '');
          video.muted = false;
          if (src) {
            var s = document.createElement('source');
            s.src = src;
            video.appendChild(s);
          } else if (videoTemplate) {
            videoTemplate.querySelectorAll('source').forEach(function (source) {
              var s = document.createElement('source');
              s.src = source.src;
              s.type = source.type;
              video.appendChild(s);
            });
          }
          modalMedia.appendChild(video);
        } else if ((type === 'youtube' || type === 'vimeo') && src) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', src);
          iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          modalMedia.appendChild(iframe);
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      var closeModal = function () {
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        if (modalMedia) modalMedia.innerHTML = '';
        document.body.style.overflow = '';
      };

      cards.forEach(function (card) {
        var btn = card.querySelector('[data-open]');
        if (!btn || btn.hasAttribute('disabled')) return;
        btn.addEventListener('click', function () { openModal(card); });
      });

      modalCloses.forEach(function (el) { el.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      /* --- Preview video play/pause on viewport visibility (legacy IntersectionObserver) --- */
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play && video.play().catch(function () {});
            } else {
              video.pause && video.pause();
              video.currentTime = 0;
            }
          });
        }, { threshold: 0.3 });
        io.observe(card);
      });
    }

    var boot = function () { document.querySelectorAll('[data-video-carousel]').forEach(init); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-video-carousel]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zlf-video-with-text-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      section.classList.add('zlf-vwt-01-section--js');

      section.querySelectorAll('[data-video]').forEach((stage) => {
        const autoplay = stage.getAttribute('data-autoplay') === 'true';
        if (autoplay) return;
        const type = stage.getAttribute('data-type');
        const poster = stage.querySelector('[data-poster]');
        const media = stage.querySelector('[data-media]');
        const player = stage.querySelector('[data-player]');
        const playBtn = stage.querySelector('[data-play]');
        if (!poster || !playBtn || !media) return;

        const activate = () => {
          poster.classList.add('is-hidden');
          media.removeAttribute('hidden');
          if (!player) return;
          if (type === 'file' && player.play) {
            player.play().catch(() => {});
            player.setAttribute('controls', '');
          } else if ((type === 'youtube' || type === 'vimeo') && player.tagName === 'IFRAME') {
            const src = player.getAttribute('data-src');
            if (src) player.setAttribute('src', src);
          }
          setTimeout(() => {
            if (poster.parentNode) poster.parentNode.removeChild(poster);
          }, 320);
        };

        playBtn.addEventListener('click', activate);
        poster.addEventListener('click', (e) => {
          if (e.target === playBtn || playBtn.contains(e.target)) return;
          activate();
        });
      });

      if (section.classList.contains('zlf-vwt-01-section--reveal')) {
        if (!('IntersectionObserver' in window)) {
          section.classList.add('zlf-vwt-01-section--in');
          return;
        }
        requestAnimationFrame(() => {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                section.classList.add('zlf-vwt-01-section--in');
                io.unobserve(section);
              }
            });
          }, { threshold: 0.15 });
          io.observe(section);
        });
      }
    }

    const boot = () => document.querySelectorAll('.zlf-vwt-01-section').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.zlf-vwt-01-section').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
